export default "__VITE_ASSET__DGYkp2sT__"